var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 .698 18.362 6H22v3a1 1 0 1 1-2 0V8h-3v3h5v3a1 1 0 0 1-2 0v-1h-3v3l.845 5H20a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2h2.14L7 15.834V13H4v1a1 1 0 0 1-2 0v-3h5V8H4v1a1 1 0 1 1-2 0V6h3.638zM8.762 6h6.476L12 3.302zM15 8H9v3h6zm0 5H9v2.67A1 1 0 0 1 9 16h6zm.31 5H8.667l-.5 3h7.65z",
    clipRule: "evenodd"
  })));
};
export default SvgGrid;